import React from 'react';
import './EventDetails.scss';

export const EventDetails: React.FC = ({ children }) => {
    return <div className="event-details">{children}</div>;
};

export const EventDetailsWrapper: React.FC = ({ children }) => {
    return <div className="event-details__wrapper">{children}</div>;
};

export const EventDetailsMain: React.FC = ({ children }) => {
    return <div className="event-details__main">{children}</div>;
};

export const EventDetailsAside: React.FC = ({ children }) => {
    return <div className="event-details__aside">{children}</div>;
};
